import React from 'react';
import { Button } from '@nooz-optics/nooz-components-lib';
import { tabButtonRight, tabsButtonLeft } from '../../../../../utils/globals';
import { useMediaQuery } from '../../../../../utils/hooks/useMediaQuery';
import { IProductVariant } from '../../../../../utils/types/contentful';
import { Radio } from '../../../Elements/Radio/radio';
import { ScrollableTabs } from '../../../Navigation/ScrollableTabs/index';
import './colorPicker.css';

export interface ColorPickerProps {
  variants: IProductVariant[];
  selectedVariant: IProductVariant;
  setSelectedVariant: Function;
}

export const ColorPicker: React.FC<ColorPickerProps> = ({
  variants,
  selectedColor,
  setSelectedColor,
}) => {
  const isWindowSmallSize = useMediaQuery('sm');
  const radioSize = isWindowSmallSize ? 'xs' : 'xs';
  const buttonSize = isWindowSmallSize ? 'sm' : 'sm';
  const margin = 'ml-2';

  const tabsButton = [
    <span className='flex bg-gray-100 relative'>
      <Button {...tabsButtonLeft} size={buttonSize} />
      <span className='bg-gradient-to-r -right-3 absolute from-gray-100 via-gray-100 w-3 h-full'></span>
    </span>,
    <span className='flex bg-gray-100 relative'>
      <span className='absolute -left-3 bg-gradient-to-l from-gray-100 via-gray-100 w-3 h-full'></span>
      <Button {...tabButtonRight} size={buttonSize} />
    </span>,
  ];

  const returnColorRadio = () =>
    variants?.map((variant, key) => {
      const color = variant.color?.shopifyKey?.toLowerCase();
      if (color) {
        const isChecked =
          selectedColor?.color?.shopifyKey?.toLowerCase() === color;
        return (
          <div className={`${key !== 0 && margin} p-1`}>
            <Radio
              size={radioSize}
              onClick={() => setSelectedColor(variant)}
              onMouseEnter={() => setSelectedColor(variant)}
              color={variant.color.hex}
              checked={isChecked}
            />
          </div>
        );
      }
    });

  return (
    <ScrollableTabs hasColorPicker buttons={tabsButton}>
      {returnColorRadio()}
    </ScrollableTabs>
  );
};
